import ChangeContentLanguageModal from '@/components/ChangeContentLanguageModal';
import Constants from '@/Constants';
import { CourseRequest } from '@/models/CourseResquest';
import { PaginationData } from '@/models/PaginationData';
import { contentService } from '@/services/ContentService';
import { courseService } from '@/services/CourseService';
import { ApplicationState } from '@/store';
import { closeModal, openModal } from '@/store/common/actions';
import { associateCourseReset, coursesRequest, createCourseReset } from '@/store/list/action';
import { ListTypes } from '@/store/list/types';
import React, { SyntheticEvent } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import MyLists from '../MyLists';
import './style.scss';

interface MenuOption {
    name: string;
    icon: string;
}

const Menu: React.FC = () => {
    const { strings, personId, modules, content } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        personId: state.identity.data.person.id,
        modules: state.appOrganization.data.modules,
        content: state.itens.currentData.content,
    }));

    const metadata = contentService.getContentMetadata(content);

    const listOfMenuOptions: MenuOption[] = [
        { name: strings.CHANGE_ITEM_LANGUAGE, icon: Constants.icons.LANGUAGE },
        { name: strings.ADD_TO_MY_LISTS, icon: Constants.icons.ADD_CIRCLE_OUTLINE },
    ];

    const dispatch = useDispatch();

    const dismissModalHandler = () => {
        dispatch(closeModal(Constants.modal.MORE_OPTIONS));
    };

    const getMyCoursesTotal = (): void => {
        dispatch(
            coursesRequest({
                excludeEnrollments: true,
                onlyMine: true,
                personId: personId,
                moduleIds: courseService.getModuleIdsForRequest(modules, [Constants.PLAYLIST_MODULE_ID]),
                paginationData: {
                    offset: 0,
                    limit: 4,
                    orderBy: 'pc.createdOn desc',
                    courseRequestSuccessType: ListTypes.MY_COURSES_SUCCESS,
                    doRequest: true,
                } as PaginationData,
            } as CourseRequest),
        );
    };

    const clickOptionHandler = (event: SyntheticEvent, name: string) => {
        event.stopPropagation();
        event.preventDefault();

        switch (name) {
            case strings.CHANGE_ITEM_LANGUAGE:
                dispatch(
                    openModal({
                        id: Constants.modal.MORE_OPTIONS,
                        layoutModal: <ChangeContentLanguageModal />,
                        isVisible: true,
                        isCloseAllowed: true,
                    }),
                );
                break;
            case strings.ADD_TO_MY_LISTS:
                getMyCoursesTotal();
                dispatch(createCourseReset());
                dispatch(associateCourseReset());
                dispatch(openModal({ id: Constants.modal.MORE_OPTIONS, layoutModal: <MyLists />, isVisible: true, isCloseAllowed: false }));
                break;
        }
    };

    return (
        <div className="menu">
            <Modal.Header closeButton onHide={dismissModalHandler}></Modal.Header>
            <Modal.Body>
                <div className="menu-container">
                    <div className="menu-sub-header">
                        <div className="label">{metadata.typeName}</div>
                        <div>
                            <img alt="" className="img-menu" src={content.mainImage} />
                        </div>
                        <div className="name">{content.name}</div>
                    </div>
                    <div className="menu-items">
                        {listOfMenuOptions.map((item, index) => (
                            <a className="menu-link" href="" key={index} onClick={(e) => clickOptionHandler(e, item.name)}>
                                <div className="item" key={index}>
                                    <i className="material-icons align-middle btn-link" key={index}>
                                        {item.icon}
                                    </i>
                                    <span>{item.name}</span>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </Modal.Body>
        </div>
    );
};

export default Menu;
